"use client";

import React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { withCn, withProps } from "@udecode/cn";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;
export const TooltipPortal = TooltipPrimitive.Portal;

// @ts-ignore
export const TooltipContent = withCn(
	withProps(TooltipPrimitive.Content, {
		sideOffset: 4,
	}),
	"z-50 overflow-hidden rounded-md border bg-white px-3 py-1.5 text-sm text-popover-foreground shadow-md"
);

export function withTooltip(Component: any) {
	return React.forwardRef(function ExtendComponent(
		{ tooltip, tooltipContentProps, tooltipProps, ...props }: any,
		ref: any
	) {
		const [mounted, setMounted] = React.useState(false);

		React.useEffect(() => {
			setMounted(true);
		}, []);

		const component = <Component ref={ref} {...(props as any)} />;

		if (tooltip && mounted) {
			return (
				<Tooltip {...tooltipProps}>
					<TooltipTrigger asChild>{component}</TooltipTrigger>

					<TooltipPortal>
						<TooltipContent {...tooltipContentProps}>{tooltip}</TooltipContent>
					</TooltipPortal>
				</Tooltip>
			);
		}

		return component;
	});
}
